"use client";
import AnimatedText from "@/components/common/AnimatedText";
import { parallaxMouseMovement } from "@/utlis/parallax";
import Image from "next/image";

import { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";
import Cal from "@calcom/embed-react";
import BookDemo from './BookDemo'
export default function Hero1() {
  useEffect(() => {
    parallaxMouseMovement();
  }, []);
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="container min-height-100vh d-flex align-items-center pt-100 pb-100 pt-sm-120 pb-sm-120">
        {/* Home Section Content */}
        <div className="home-content text-start">
          <div className="row">
            {/* Home Section Text */}
            <div className="col-md-4 d-flex align-items-center mb-sm-60">
              <div>
                <h1
                  className="section-caption-border mb-30 mb-xs-20"
                >
                  All In One Schedule Demo
                </h1>
                {/* hs-title-1 fadeInUp */}
                <h2 className="  section-title-small mb-30">
                  {/* // Discover the Power of GetBiz Solutions Book Your Demo Today! */}
                  Book Your Demo Today!
                </h2>
                <p className="section-descr mb-20">
                  Experience how GetBiz Solutions can streamline your business operations with our all-in-one suite of HRMS, CRM, and business tools. Book a personalized demo and see how we help businesses optimize processes, increase efficiency, and drive growth.
                </p>
                <div className="row ">
                  <div
                    className="d-flex fadeInUp"
                  >
                    <div className="features-list-icon">
                      <i className="mi-arrow-right" />
                    </div>
                    <div className="features-list-text">
                      Effortless Employee Management
                    </div>
                  </div>
                  <div
                    className="d-flex mt-10 fadeInUp"
                  >
                    <div className="features-list-icon">
                      <i className="mi-arrow-right" />
                    </div>
                    <div className="features-list-text">
                      Business Growth Solutions
                    </div>
                  </div>
                  <div
                    className="d-flex mt-10 fadeInUp"
                  >
                    <div className="features-list-icon">
                      <i className="mi-arrow-right" />
                    </div>
                    <div className="features-list-text">
                      Streamlined Operations
                    </div>
                  </div>

                </div>
              </div>
            </div>
            {/* End Home Section Text */}
            {/* Stack Images */}
            <div className="col-md-8 -offset-md-1 d-flex align-items-center">
              {/* <Image
                src="/assets/images/stack-image-1.jpg"
                alt="Image Description"
                width={600}
                height={800}
              /> */}
              {/* <Cal calLink="rick/get-rick-rolled"></Cal> */}
              {/* <div className="App">
                <h1>Discover the Power of GetBiz Solutions Book Demo</h1>
                <Cal calLink="getbiz.solutions/30min"></Cal>
              </div> */}
              <BookDemo />
            </div>
            {/* End Stack Images */}
          </div>
        </div>
        {/* End Home Section Content */}
        {/* Scroll Down */}
        <div
          className="local-scroll scroll-down-wrap-type-1 wow fadeInUp"
          data-wow-offset={0}
        >
          <div className="container">
            <a href="#about" className="scroll-down-1">
              <div className="scroll-down-1-icon">
                <i className="mi-arrow-down" />
              </div>
              <div className="scroll-down-1-text">Scroll Down</div>
            </a>
          </div>
        </div>
        {/* End Scroll Down */}
      </div>
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="jTea_8Fk5Ns"
        onClose={() => setOpen(false)}
      />
    </>
  );
}
